// Whether a list's saved filter has actually changed, for the "reset to page 1" decision
// in each list's savedFilter watcher.
//
// "No filter" arrives in more than one spelling: the dropdown's clear button stores null,
// the store modules start with {}, and a soft re-entry spreads the store value into a fresh
// object, which turns null into {}. Comparing by id makes them all the same thing, so the
// first Back after clearing a saved filter no longer lands on page 1.
export function savedFilterChanged(oldFilter, newFilter) {
  const oldId = oldFilter && oldFilter.id !== undefined ? oldFilter.id : null
  const newId = newFilter && newFilter.id !== undefined ? newFilter.id : null
  return oldId !== newId
}
